import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    attrs: {
      "fluid": ""
    }
  }, [_vm.selectStatePrompt ? _c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('IS.Warnapp.admin.statePickConfirmHeader'),
      "open": _vm.selectStatePrompt,
      "buttons": [{
        text: _vm.$i18n_t('Common.close'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('IS.Warnapp.admin.statePickConfirmButton'),
        color: _vm.color,
        emit: 'pickState'
      }]
    },
    on: {
      "cancel": function ($event) {
        _vm.pickedKeys = {};
        _vm.selectStatePrompt = false;
      },
      "pickState": function ($event) {
        _vm.pickedKeys = {};
        _vm.selectStatePrompt = false;
        _vm.statePickConfirmed();
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$i18n_t('IS.Warnapp.admin.statePickConfirmText1')) + "\n    "), _c('code', [_vm._v(_vm._s(_vm.selectedState.key))]), _vm._v("\n    " + _vm._s(_vm.$i18n_t('IS.Warnapp.admin.statePickConfirmText2')) + "\n    "), _c('code', [_vm._v(_vm._s(_vm.selectedStateKey))]), _vm._v("\n    " + _vm._s(_vm.$i18n_t('IS.Warnapp.admin.statePickConfirmText3')) + "\n  ")]) : _vm._e(), _c('core-header', {
    attrs: {
      "headline": `${_vm.$i18n_t('IS.Warnapp.drawer.isWarnapp')} ${_vm.$i18n_t('IS.Warnapp.drawer.isWarnappAdmin')}`,
      "subtitle": _vm.$i18n_t('IS.Warnapp.admin.headerText')
    }
  }), _c(VRow, {
    staticClass: "pa-4 pt-0",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "two-cols-dynamic-1",
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "6",
      "lg": "4"
    }
  }, [_c('core-n20Card', [_c(VCardText, {
    staticClass: "scroll-card pa-0"
  }, [_c(VRow, [_c(VCol, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('Common.search'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "append-icon": "fal fa-search",
      "clearable": "",
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "append-outer",
      fn: function () {
        return [_vm._t("search-field-outer")];
      },
      proxy: true
    }], null, true),
    model: {
      value: _vm.search,
      callback: function ($$v) {
        _vm.search = $$v;
      },
      expression: "search"
    }
  }), _c('core-dtwin-tree-default', {
    ref: "twin-tree",
    attrs: {
      "searchTerm": _vm.search,
      "canSelectDisabledTwins": false,
      "cached": "",
      "loadFullDtwinData": ""
    },
    on: {
      "onSelectedChange": e => {
        if (e && e.id) {
          _vm.selected = e;
          _vm.loadDigitalTwinStates(e.id);
        }
      },
      "initialDtwins": _vm.loadedInitialDtwins
    }
  })], 1)], 1), _c(VRow, [_vm.treeLoading ? _c(VCol, {
    staticClass: "text-center"
  }, [_c(VProgressCircular, {
    attrs: {
      "size": 30,
      "width": 2,
      "color": _vm.color,
      "indeterminate": ""
    }
  }), _c('h6', {
    staticClass: "category grey--text mt-4"
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('Common.digitalTwins.loadingTwins')) + "\n              ")])], 1) : _vm._e()], 1)], 1)], 1)], 1), _c(VCol, {
    staticClass: "two-cols-dynamic-2",
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "6",
      "lg": "8"
    }
  }, [_vm.selected ? _c('core-n20Card', [_c('h3', [_vm._v(_vm._s(_vm.selected.title))]), _c('p', {
    staticClass: "description"
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('IS.Warnapp.admin.bodyText')) + "\n        ")]), _c('h4', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.attachmentHeadline')))]), _c('core-dtwin-attachments', {
    ref: "fileAttachments",
    attrs: {
      "selectableImages": false,
      "attachments": _vm.warnAppAttachments,
      "accept": _vm.uploadAccept
    },
    on: {
      "update": _vm.attachmentsUpdated,
      "files:custom-selection": _vm.customFileSelectionHandler
    }
  }, [_c('template', {
    slot: "headline"
  }, [_c('p', {
    staticClass: "my-2",
    attrs: {
      "v-html": _vm.$i18n_t('IS.Warnapp.admin.attachmentsText')
    }
  })])], 2), _c('h4', [_vm._v(_vm._s(_vm.$i18n_t('IS.Warnapp.drawer.isWarnapp')) + " " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.dataStates')))]), _c('core-n20Card', {
    staticClass: "dt-card-text-01",
    attrs: {
      "offset": "20"
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_c(VBtn, {
          class: `v-btn-x mx-1 v-btn--rounded bg-rounded-button-${_vm.color}`,
          attrs: {
            "disabled": !_vm.warnStateChanged,
            "color": _vm.color,
            "rounded": "",
            "text": ""
          },
          on: {
            "click": function ($event) {
              return _vm.saveStates();
            }
          }
        }, [_c(VIcon, {
          attrs: {
            "left": ""
          }
        }, [_vm._v("fas fa-save")]), _vm._v("\n                " + _vm._s(_vm.$i18n_t('Common.save')) + "\n            ")], 1)];
      },
      proxy: true
    }], null, false, 744508764)
  }, [_vm.warnAppValidGauge ? [_c('core-n20Card', {
    staticClass: "mt-3"
  }, [_c(VRow, {
    staticClass: "my-0 py-0",
    attrs: {
      "align": "center"
    }
  }, [_c(VCol, {
    staticClass: "my-0 py-0"
  }, [_c(VIcon, {
    attrs: {
      "color": "green",
      "small": ""
    }
  }, [_vm._v("fal fa-badge-check")]), _vm._v("\n                   \n                  " + _vm._s(_vm.warnAppValidGauge.properties.title) + " -- " + _vm._s(_vm.warnAppValidGauge.properties.unit) + "\n                ")], 1), _c(VCol, {
    staticClass: "my-0 py-0",
    attrs: {
      "align": "right"
    }
  }, [_c(VBtn, {
    class: `v-btn-x mx-1 v-btn--rounded bg-rounded-button-${_vm.color}`,
    attrs: {
      "color": _vm.color,
      "rounded": "",
      "text": ""
    },
    on: {
      "click": function ($event) {
        return _vm.resetGaugeState();
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "left": ""
    }
  }, [_vm._v("fal fa-undo")]), _vm._v("\n                      " + _vm._s(_vm.$i18n_t('Common.reset')) + "\n                  ")], 1)], 1)], 1), _c('core-dtwin-state-edit-visual', {
    ref: "stateVisualComp",
    attrs: {
      "value": _vm.warnAppValidGauge,
      "helpText": _vm.$i18n_t('IS.Warnapp.admin.gaugeHelpText'),
      "hideSelection": "",
      "hidePreview": ""
    },
    on: {
      "value:updated": _vm.updateWarnAppValidGauge
    }
  })], 1)] : _vm._e(), _vm.warnAppValidUpperLimit || _vm.warnAppValidLowerLimit ? [_c('core-n20Card', {
    staticClass: "mt-3"
  }, [_c(VRow, [_vm.warnAppValidUpperLimit ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VRow, [_c(VCol, [_c(VIcon, {
    attrs: {
      "color": "green",
      "small": ""
    }
  }, [_vm._v("fal fa-badge-check")]), _vm._v("\n                        " + _vm._s(_vm.$i18n_t('IS.Warnapp.admin.upperLimit')) + "\n                    ")], 1)], 1), _c(VTextField, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.visualization.maxValue'),
      "type": "number",
      "required": "",
      "hide-details": ""
    },
    model: {
      value: _vm.warnAppValidUpperLimit.value.value,
      callback: function ($$v) {
        _vm.$set(_vm.warnAppValidUpperLimit.value, "value", $$v);
      },
      expression: "warnAppValidUpperLimit.value.value"
    }
  }), _c('p', {
    staticClass: "description mt-3"
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('IS.Warnapp.admin.upperLimitText')) + "\n                  ")])], 1) : _vm._e(), _vm.warnAppValidLowerLimit ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VRow, [_c(VCol, [_c(VIcon, {
    attrs: {
      "color": "green",
      "small": ""
    }
  }, [_vm._v("fal fa-badge-check")]), _vm._v("\n                        " + _vm._s(_vm.$i18n_t('IS.Warnapp.admin.lowerLimit')) + "\n                    ")], 1)], 1), _c(VTextField, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.visualization.minValue'),
      "type": "number",
      "required": "",
      "hide-details": ""
    },
    model: {
      value: _vm.warnAppValidLowerLimit.value.value,
      callback: function ($$v) {
        _vm.$set(_vm.warnAppValidLowerLimit.value, "value", $$v);
      },
      expression: "warnAppValidLowerLimit.value.value"
    }
  }), _c('p', {
    staticClass: "description mt-3"
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('IS.Warnapp.admin.lowerLimitText')) + "\n                  ")])], 1) : _vm._e()], 1)], 1)] : _vm._e(), !_vm.warnAppValidGauge || !_vm.warnAppValidUpperLimit || !_vm.warnAppValidLowerLimit ? [_c('core-n20Card', {
    staticClass: "mt-3"
  }, [_c('p', {
    staticClass: "description",
    attrs: {
      "v-html": _vm.$i18n_t('IS.Warnapp.admin.stateListText')
    }
  }), _c(VRow, {
    attrs: {
      "align": "center"
    }
  }, [_vm._l(_vm.warnAppStates, function (state) {
    return [_c(VCol, {
      attrs: {
        "cols": "6",
        "lg": "3",
        "align": "right"
      }
    }, [_vm._v("\n                    " + _vm._s(state.properties.title) + " -- " + _vm._s(state.properties.unit) + "   =>\n                  ")]), _c(VCol, {
      attrs: {
        "cols": "6",
        "lg": "3"
      }
    }, [_c(VSelect, {
      attrs: {
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "items": _vm.warnAppTypesForState(state),
        "label": _vm.$i18n_t('Common.type'),
        "dense": "",
        "hide-details": ""
      },
      on: {
        "change": e => _vm.warnAppTypePicked(state, e)
      },
      model: {
        value: _vm.pickedKeys[state.key],
        callback: function ($$v) {
          _vm.$set(_vm.pickedKeys, state.key, $$v);
        },
        expression: "pickedKeys[state.key]"
      }
    })], 1)];
  })], 2), _c(VRow, {
    attrs: {
      "align": "center"
    }
  }, [_vm.warnAppValidGauge && !_vm.warnAppValidLowerLimit ? _c(VCol, {
    attrs: {
      "cols": "6",
      "align": "center"
    }
  }, [_c(VBtn, {
    class: `v-btn-x mx-1 v-btn--rounded bg-rounded-button-${_vm.color}`,
    attrs: {
      "color": _vm.color,
      "rounded": "",
      "text": ""
    },
    on: {
      "click": function ($event) {
        return _vm.createAlarmState('low');
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "left": ""
    }
  }, [_vm._v("fal fa-plus")]), _vm._v("\n                      " + _vm._s(_vm.$i18n_t('IS.Warnapp.admin.createLowerLimit')) + "\n                  ")], 1)], 1) : _vm._e(), _vm.warnAppValidGauge && !_vm.warnAppValidUpperLimit ? _c(VCol, {
    attrs: {
      "cols": "6",
      "align": "center"
    }
  }, [_c(VBtn, {
    class: `v-btn-x mx-1 v-btn--rounded bg-rounded-button-${_vm.color}`,
    attrs: {
      "color": _vm.color,
      "rounded": "",
      "text": ""
    },
    on: {
      "click": function ($event) {
        return _vm.createAlarmState('high');
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "left": ""
    }
  }, [_vm._v("fal fa-plus")]), _vm._v("\n                      " + _vm._s(_vm.$i18n_t('IS.Warnapp.admin.createUpperLimit')) + "\n                  ")], 1)], 1) : _vm._e()], 1)], 1)] : _vm._e()], 2)], 1) : _vm._e()], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };